<template lang="pug">
  .container-main-mobile-edit
    c-header
      template(slot="left")
        h3 资料修改
      template(slot="right")
        el-button(@click="abortEdit") 取消
    
    data-row(label="商户类型") {{ source.type | type }}
    template(v-if="source.type === 1")
      .data-block
        data-row(label="公司名称", required)
          el-input(v-model="source.mch_name")
        data-row(label="法人姓名", required)
          el-input(v-model="source.legal_per_name")
        data-row(label="营业执照号", required)
          el-input(v-model="source.business_license")
        data-row(label="")
          el-button(type="primary", @click="copyLicense(source.business_license)", :disabled="!source.business_license") 复制营业执照号
        data-row(label="组织机构代码", required)
          el-input(v-model="source.organization_code")
        data-row(label="税务登记证件号", required)
          el-input(v-model="source.tex_registration_no")
        data-row(label="注意")
          .grey 对于“三证合一、一照一码”的营业执照，请在“营业执照号”、“税务登记证件号”和“组织机构代码”字段都填写统一社会信用代码。
        data-row(label="结算方式")
          .grey {{ source.settle_type | settle_type_long }}
        data-row(label="商户电话", required)
          el-input(v-model="source.tel")
        data-row(label="公司地址")
          el-input(v-model="source.business_address")
      .data-block
        data-row(label="责任人姓名", required)
          el-input(v-model="source.resp_per_name")
        data-row(label="责任人证件类型", required)
          el-select(v-model="source.resp_per_id_type")
            el-option(value="01", label="身份证")
        data-row(label="责任人证件号", required)
          el-input(v-model="source.resp_per_id_no", required)
      .data-block
        data-row(label="责任人手机", required, is-link, @click="toSetPhone()") {{ source.resp_per_telephone_no || '未绑定' }}
        //- data-row(label="")
          el-button(type="primary", @click="toSetPhone()")
            template(v-if="!source.resp_per_telephone_no") 绑定手机
            template(v-else) 修改手机
        data-row(label="责任人邮箱", required, is-link, @click="toSetEmail()") {{ source.resp_per_email || '未绑定' }}
        //- data-row(label="") 
          el-button(type="primary", @click="toSetEmail()")
            template(v-if="!source.resp_per_email") 绑定邮箱
            template(v-else) 修改邮箱
      .data-block
        data-row(label="营业执照")
          el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
            :show-file-list="false", :on-change="(file) => uploadChange(file, 'business_license_pic_preview', 'business_license_pic')")
            el-button(type="primary") 选择文件
        data-row(label="")
          img(v-if="source.business_license_pic", :src="source.business_license_pic | image", 
            @click="$zoom($options.filters.image(source.business_license_pic))").mch-image
          img(v-else-if="source.business_license_pic_preview", :src="source.business_license_pic_preview",
            @click="$zoom(source.business_license_pic_preview)").mch-image
          template(v-else) 未上传
      
    template(v-else-if="source.type === 2")
      .data-block
        data-row(label="个人姓名", required)
          el-input(v-model="source.resp_per_name")
        data-row(label="证件类型", required)
          el-select(v-model="source.resp_per_id_type")
            el-option(value="01", label="身份证")
        data-row(label="证件号码", required)
          el-input(v-model="source.resp_per_id_no")
        data-row(label="联系地址")
          el-input(v-model="source.business_address")
        data-row(label="结算方式")
          .grey {{ source.settle_type | settle_type_long }}
      .data-block
        data-row(label="手机", required, is-link, @click="toSetPhone()") {{ source.resp_per_telephone_no || '未绑定' }}
        //- data-row(label="")
          el-button(type="primary", @click="toSetPhone()")
            template(v-if="!source.resp_per_telephone_no") 绑定手机
            template(v-else) 修改手机
        data-row(label="邮箱", required, is-link, @click="toSetEmail()") {{ source.resp_per_email || '未绑定' }}
        //- data-row(label="")
          el-button(type="primary", @click="toSetEmail()")
            template(v-if="!source.resp_per_email") 绑定邮箱
            template(v-else) 修改邮箱
      .data-block
        data-row(label="营业执照")
          el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
            :show-file-list="false", :on-change="(file) => uploadChange(file, 'business_license_pic_preview', 'business_license_pic')")
            el-button(type="primary") 选择文件
        data-row(label="")
          img(v-if="source.business_license_pic", :src="source.business_license_pic | image", 
            @click="$zoom($options.filters.image(source.business_license_pic))").mch-image
          img(v-else-if="source.business_license_pic_preview", :src="source.business_license_pic_preview",
            @click="$zoom(source.business_license_pic_preview)").mch-image
          template(v-else) 未上传
      .data-block
        data-row(label="证件正面")
          el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
            :show-file-list="false", :on-change="(file) => uploadChange(file, 'resp_per_id_positive_preview', 'resp_per_id_positive')")
            el-button(type="primary") 选择文件
        data-row(label="")
          img(v-if="source.resp_per_id_positive", :src="source.resp_per_id_positive | image",
            @click="$zoom($options.filters.image(source.resp_per_id_positive))").mch-image
          img(v-else-if="source.resp_per_id_positive_preview", :src="source.resp_per_id_positive_preview",
            @click="$zoom(source.resp_per_id_positive_preview)").mch-image
          template(v-else) 未上传
      .data-block
        data-row(label="证件反面")
          el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
            :show-file-list="false", :on-change="(file) => uploadChange(file, 'resp_per_id_opposite_preview', 'resp_per_id_opposite')")
            el-button(type="primary") 选择文件
        data-row(label="")
          img(v-if="source.resp_per_id_opposite", :src="source.resp_per_id_opposite | image", 
            @click="$zoom($options.filters.image(source.resp_per_id_opposite))").mch-image
          img(v-else-if="source.resp_per_id_opposite_preview", :src="source.resp_per_id_opposite_preview",
            @click="$zoom(source.resp_per_id_opposite_preview)").mch-image
          template(v-else) 未上传
    .data-block
      data-row
        el-button(type="primary", @click="saveEdit()", slot="label") 保存
        el-button(@click="abortEdit") 取消

    verifier(ref="verifyEmail", @success_verify="toModifyEmail", scene="MODIFY_EMAIL", opt="MCH_VERIFY")
    verifier(ref="modifyEmail", @success_bind="modifyEmailSuccess", scene="MODIFY_EMAIL", opt="MCH_BINDING", method="email", is-modify)
    verifier(ref="bindingEmail", @success_bind="modifyEmailSuccess", scene="MODIFY_EMAIL", opt="MCH_BINDING", method="email", is-binding)

    verifier(ref="verifyPhone", @success_verify="toModifyPhone", scene="MODIFY_MOBILE", opt="MCH_VERIFY")
    verifier(ref="modifyPhone", @success_bind="modifyPhoneSuccess", scene="MODIFY_MOBILE", opt="MCH_BINDING", method="phone", is-modify)
    verifier(ref="bindingPhone", @success_bind="modifyPhoneSuccess", scene="MODIFY_MOBILE", opt="MCH_BINDING", method="phone", is-binding)

    verifier(ref="modifyMch", @success_verify="toSaveEdit", @abort="abortEdit", scene="MODIFY_INFO", opt="MCH_VERIFY")
</template>

<script>
export default {
  data () {
    return {
      loading:  false,
      source:   {},

      uploadURL:  '/mch_web/v1/upload_picture',
    };
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo;
    },
  },
  filters: {
    type (source) {
      switch (source) {
        case 1:     return '公司';
        case 2:     return '个人';
        default:    return source;
      }
    },
    status (source) {
      if (!source && source !== 0) {
        return '-';
      }
      switch (parseInt(source)) {
        case 1:
          return "填写中";
        case 2:
          return "审批中";
        case 3:
          return "审批通过";
        case 4:
          return "审批失败";
        case 5:
          return "用户撤回修改";
        case 6:
          return "审批中";
        default:  return source;
      }
    },
    settle_type (source) {
      switch (source) {
        case 1:     return '银行账号';
        case 2:     return '钱包账号';
        default:    return source;
      }
    },
    resp_per_id_type (source) {
      switch (source) {
        case '01':  return '身份证';
        default:    return source;
      }
    },
  },
  methods: {
    getUserInfo () {
      return this.$store.dispatch('GET_USER_INFO');
    },
    getMchDetail () {
      const { uname } = this.userInfo;
      this.loading = true;
      return this.$store.dispatch('GET_MCH_DETAIL', uname).then((data) => {
        this.source = data;
        return data;
      }).catch(({ code, msg }) => {
        this.$alert(`商家资料获取失败。${code}：${msg}`, {
          type:     'error'
        });
      }).finally(() => {
        this.loading = false;
      });
    },

    copyLicense (content) {
      if (content) {
        this.$clipboard(content);
        this.source.organization_code = content;
        this.source.tex_registration_no = content;
        this.$message({
          type:     'success',
          message:  '营业执照号已复制',
        });
      }
    },

    uploadChange (file, previewKey, urlKey) {
      const { size } = file;
      if (size < 1 * 1024 * 1024) {
        const fr = new FileReader();
        fr.onload = e => {
        //   this.loading = true;
          const result = e.target.result;
          this.$set(this.source, previewKey, result);
          const pic_data = result.split(",")[1];

          //获取尾缀名
          const beginIdx = name.lastIndexOf(".");
          const endIdx = name.length;
          const ext = name.substring(beginIdx + 1, endIdx);
          const params = {
            pic_data,
            ext
          };
          this.$store.dispatch('UPLOAD', headlessResult).then(({ url }) => {
            this.$set(this.source, urlKey, url);
          }).catch(({ code, msg }) => {
            this.$alert(`商家资料图片上传失败。${code}：${msg}`, {
              type:     'error'
            });
          });
        };
        fr.readAsDataURL(file.raw);
      } else {
        this.$alert('图片上传失败。文件大小超过1MB。', {
          type:     'error'
        });
      }
    },

    back () {
      this.$router.push('/main-mobile');
    },
    abortEdit () {
      this.$confirm('是否确认放弃未保存的商家信息？', '提示').then(() => {
        this.back();
      }).catch(() => {

      });
    },

    saveEdit () {
      if (this.validate()) {
        this.$refs.modifyMch.init();
      }
    },
    toSaveEdit (biz_ticket) {
      this.loading = true;
      this.source.biz_ticket = biz_ticket;
      const action = this.source.type === 1 ? 'EDIT_COMPANY_DETAIL' : 'EDIT_PERSON_DETAIL';
      this.$store.dispatch(action, this.source).then(() => {
        this.getMchDetail();
        this.back();

        this.$message({
          type:     'success',
          message:  '您的商家资料已提交审核'
        });
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `修改失败。${code}：${msg}`,
        });
      }).finally(() => {
        this.loading = false;
      });
    },

    validate () {
      const type = this.source.type;
      if (!this.source.mch_name && type === 1) {
        this.$message({
          type:     'warning',
          message:  `请输入公司名称`
        });
        return false;
      } else if ((!this.source.legal_per_name && type === 1) || (!this.source.resp_per_name && type === 2)) {
        const message = type === 1 ? '请输入法人姓名' : '请输入个人姓名';
        this.$message({
          type:     'warning',
          message,
        });
        return false;
      } else if (type === 1 && (!this.source.business_license || !this.source.organization_code || !this.source.tex_registration_no)) {
        this.$message({
          type:     'warning',
          message:  `请输入营业执照号、组织机构代码和税务登记证件号`
        });
        return false;
      } else if (!this.source.tel && type === 1) {
        this.$message({
          type:     'warning',
          message:  `请输入商户电话`
        });
        return false;
      } else if (!this.source.resp_per_name && type === 1) {
        this.$message({
          type:     'warning',
          message:  `请输入责任人姓名`
        });
        return false;
      } else if (!this.source.resp_per_id_no) {
        const message = type === 1 ? '请输入责任人证件号' : '请输入证件号码';
        this.$message({
          type:     'warning',
          message,
        });
        return false;
      } else if (!this.source.resp_per_id_no.match(this.$regex.idRegex) && this.source.resp_per_id_type === '01') {
        this.$message({
          type:     'warning',
          message:  `请输入有效的身份证号码`
        });
        return false;
      }
      return true;
    },

    toSetEmail () {
      if (this.source.resp_per_email) {
        this.toModifyEmail();
      } else {
        this.toBindEmail();
      }
    },
    toBindEmail () {
      this.$refs.bindingEmail.init();
    },
    toModifyEmail (biz_ticket) {
      if (!biz_ticket) {
        this.$refs.verifyEmail.init();
      } else {
        this.biz_ticket = biz_ticket;
        this.$refs.modifyEmail.init(biz_ticket);
      }
    },
    modifyEmailSuccess () {
      this.getMchDetail();
    },

    toSetPhone () {
      if (this.source.resp_per_telephone_no) {
        this.toModifyPhone();
      } else {
        this.toBindPhone();
      }
    },
    toBindPhone () {
      this.$refs.bindingPhone.init();
    },
    toModifyPhone (biz_ticket) {
      if (!biz_ticket) {
        this.$refs.verifyPhone.init();
      } else {
        this.biz_ticket = biz_ticket;
        this.$refs.modifyPhone.init(biz_ticket);
      }
    },
    modifyPhoneSuccess () {
      this.getMchDetail();
    },
  },
  mounted () {
    this.getUserInfo().then(() => {
      this.getMchDetail();
    });
  },
};
</script>

<style lang="less">
@import (reference) "../assets/general";
.container-main-mobile-edit {
  -hint {
    .flex(flex-start, space-between);
  }
}
</style>
